import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AsyncPipe, NgForOf } from '@angular/common';
import { CategoriesStore } from '@us/web/categories/data-access';
import { TuiButtonModule, TuiDialogContext } from '@taiga-ui/core';
import { CategoryWithoutItems } from '@us/web/shared/data-access';
import { POLYMORPHEUS_CONTEXT } from '@tinkoff/ng-polymorpheus';

@Component({
    selector: 'us-select-category',
    standalone: true,
    imports: [NgForOf, TuiButtonModule, AsyncPipe],
    templateUrl: './select-category.component.html',
    styleUrls: ['./select-category.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectCategoryComponent {
    private readonly categoriesStore = inject(CategoriesStore);

    private readonly context = inject(POLYMORPHEUS_CONTEXT) as TuiDialogContext<
        { category: CategoryWithoutItems },
        { selectedCategory: CategoryWithoutItems | null }
    >;

    readonly categories$ = this.categoriesStore.categories$;
    readonly selectedCategory: CategoryWithoutItems | null = this.context.data.selectedCategory;

    handleSelect(category: CategoryWithoutItems): void {
        this.context.completeWith({ category });
    }
}
